import React, { useContext } from "react";
import Img from "../Img";
import { getConfiguration, getCurrencyValue } from "../../data/utils";
import { BetslipContext } from "../../data/betslip/BetslipConf";
import { getLabel } from "../../InitData";

function getAmount(coupon) {
    let amount = 0;
    // if (coupon.selectedContainer === 'singlebets') {
    // 	amount = coupon.amountSingle;
    // } else if (coupon.selectedContainer === 'multibets') {
    	amount = coupon.selectedContainer === 'systembets'? coupon.amountSystem : coupon.amountMulti;
    // }
    const conf = getConfiguration();
    return getCurrencyValue(amount, conf.cs.m, conf.cs.nd, conf.cs.ct);
}

export default function BetslipBar(props) {
    const conf = getConfiguration();
    const betslipContext = useContext(BetslipContext);
    const betslipData = betslipContext.getBetslipData();

    if (betslipData == null) {
        return null;
    }
    
    const noEvents = betslipContext.getCouponSelectionsNum() === 0;
    const showContent = !props.toggled && !noEvents;
    const couponKey = betslipData.selectedCoupon;
    const coupon = betslipData.coupons[couponKey];

    let maxPaidPotentialWinning = null;
    if (coupon.selectedContainer === 'systembets') {
    	if (conf.sbmw !== 0 && conf.mwspw) {
    		if (coupon.potentialWinning > conf.sbmw) {
    			maxPaidPotentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    } else {
    	if (conf.mbmw !== 0 && conf.mwmpw) {
    		if (coupon.potentialWinning > conf.mbmw) {
    			maxPaidPotentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    }
    
    const winnings = maxPaidPotentialWinning ? maxPaidPotentialWinning : betslipContext.getPotentialWin();

    return (
        <div className="b_3" onClick={props.toggleBetslip}>
            <Img className="b_3_1" src="icon_chevron.svg" height="24px" width="24px" data-rotate={props.toggled ? '' : '180'} />
            <div className="b_3_2">
                <div className="b_3_2_1">{betslipContext.getCouponSelectionsNum()}</div>
            </div>
            {showContent &&
                <div className="b_3_3">
                    <div className="b_3_3_1">
                        <div className="b_3_3_1_1">{getLabel('general.importo', getLabel('betslip.stake'))}</div>
                        <div className="b_3_3_1_2">{getAmount(coupon)}</div>
                    </div>
                    {
                    	coupon.selectedContainer !== 'systembets' && 
                    	<div className="b_3_3_1">
                        	<div className="b_3_3_1_1">{getLabel('mybets.quota')}</div>
                        	<div className="b_3_3_1_2">{coupon.totalOdd}</div>
                    	</div>
                    }

                    <div className="b_3_3_1">
                        <div className="b_3_3_1_1">{getLabel('carrello.winnings', getLabel('betslip.winnings'))}</div>
                        <div className="b_3_3_1_2">{winnings}</div>
                    </div>
                </div>
            }
        </div>
    );
}
